import getUserProperties from "@/users/getUserProperties";

/**
 * returns the district UUID of the user as a string value.
 * @param {Object} user - a user, currently considered to be either a principal or district leader
 *
 * @return {string} distict UUID of the user
 */
const getDistrictUUID = (user) => {
  if (!user) return null;

  const { isAuthorizedDistrictAdmin } = getUserProperties(user);

  return isAuthorizedDistrictAdmin
    ? user.district_admin.district?.unique_id
    : user?.schools?.[0]?.districts?.[0]?.unique_id;
};

export default getDistrictUUID;
